import { render, staticRenderFns } from "./prescription-base.vue?vue&type=template&id=2f1b1ed1&scoped=true&lang=pug&"
import script from "./prescription-base.vue?vue&type=script&lang=ts&"
export * from "./prescription-base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1b1ed1",
  null
  
)

export default component.exports